// @flow
import _ from 'lodash';
import type { TPlayer } from '../../modules/types';

export const getStatsCostDividedByAveragePoints = (player: TPlayer) => {
	const { cost, stats } = player,
		{ avg_points } = stats;

	return parseInt(avg_points ? (cost / avg_points) : 0, 10);
};

export const getPlayerScoreByRound = (
	player: TPlayer,
	round_id: number,
	default_val: string | typeof undefined
) => {
	if (parseInt(round_id, 10) < 1) {
		default_val = '-';
	}

	return _.get(player, `stats.scores[${round_id}]`, default_val);
};

export const getPlayerCustomScoreByRound = (
	player: TPlayer,
	round_id: number,
	default_val: string | typeof undefined
) => {
	if (parseInt(round_id, 10) < 1) {
		default_val = '-';
	}

	return _.get(player, `custom_stats.scores[${round_id}]`, default_val);
};

export const getPlayerProjectedScoreByRound = (
	player: TPlayer,
	round_id: number,
	default_val: string | typeof undefined,
) => {
	if (parseInt(round_id, 10) < 1) {
		default_val = '-';
	}

	return _.get(player, `stats.proj_scores[${round_id}]`, default_val);
};

export const getPlayerCustomProjectedScoreByRound = (
	player: TPlayer,
	round_id: number,
	default_val: string | typeof undefined,
) => {
	if (parseInt(round_id, 10) < 1) {
		default_val = '-';
	}

	return _.get(player, `custom_stats.proj_scores[${round_id}]`, default_val);
};

// In selected round 1, return -
// In selected round 2, round diff and season diff are same values
// In selected round X, returns comparison between round X and round X - 1
export const calculateRoundDiffFromSelectedRound = (
	player: TPlayer,
	selected_round_id: number
): number | string => {

	// Early return if no stats prices
	if (!_.get(player, 'stats.prices')) {
		return "-";
	}

	if (selected_round_id === 1) {
		// No previous round to compare against for round 1's own diff, return -
		return "-";
	}

	// Price at the end of the selected round
	const priceAtSelectedRound = _.get(
		player,
		`stats.prices[${selected_round_id}]`
	);

	// Price at the end of the round *before* the selected round
	const priceAtPreviousRound = _.get(
		player,
		`stats.prices[${selected_round_id - 1}]`
	);

	if (
		priceAtSelectedRound === undefined ||
		priceAtPreviousRound === undefined
	) {
		return "-";
	}

	const diff = priceAtSelectedRound - priceAtPreviousRound;
	return diff;
};

// In selected round 1, return -
// In selected round 2, round diff and season diff are same values
// In selected round X, returns comparison between round X and round 1
export const calculateSeasonDiffFromSelectedRound = (
	player: TPlayer,
	selected_round_id: number
): number | string => {

	// Early return if no stats prices
	if (!_.get(player, 'stats.prices')) {
		return "-";
	}

	if (selected_round_id === 1) {
		// No previous round to compare against for round 1's own diff, return -
		return "-";
	}

	// Price at the end of the selected round
	const priceAtSelectedRound = _.get(
		player,
		`stats.prices[${selected_round_id}]`
	);
	// Price at the end of round 1 (season start price for diff calculation)
	const priceAtRound1 = _.get(player, "stats.prices[1]");

	if (
		priceAtSelectedRound === undefined ||
		priceAtRound1 === undefined
	) {
		return "-";
	}

	const diff = priceAtSelectedRound - priceAtRound1;
	return diff;
};